interface ISiteLabelInputConfig
    extends ISiteLabelConfig {
    popout: SiteLabelPopout;
    setValueTimeout: number;
}

class SiteLabelInput 
    extends SiteLabel<string, ISiteLabelInputConfig> {

    private _input: IQueryElement;
    private _timer?: number;

    constructor(card: SiteCard, model: ISiteModel, modelData: ISiteModel, element: HTMLElement) {
        super(card, model, modelData, element);

        let input = this.query("input, textarea").first();

        if(input === null)
            throw 'SiteLabelInput: Missing element(s)';

        this._input = input;

        this.setConfig(this.config);
    }

    getInput() {
        return this._input;
    }

    setConfig(config: ISiteLabelInputConfig) {
        if (config.setValueTimeout !== 0) {
            this._input.on("keyup", e => {
                if (this._timer)
                    window.clearTimeout(this._timer);

                this._timer = window.setTimeout(() => this.setValue(this.getValue()), config.setValueTimeout);
            })
        }
    }

    defaultConfig(): ISiteLabelInputConfig {
        return {
            popout: "normal",
            setValueTimeout: 0,
            scroll: "top"
        }
    }

    makeActive() {
        if(super.makeActive()) {
            this._input.select();
            return true;
        }
        return false;
    }

    getValue() {
        let value = this._input.getVal();
        return !value ? null : value;
    }
    setValue(value: string | null) {
        super.setValue(value);
        this._input.setVal(value);
    }
} 